export const DEFAULT_ANALYSIS_START_YEAR = 2024;
export const LABEL_MAX_LENGTH = 20;
